import { ApiServiceHelper } from '.'

import { HOME } from '@/modules/dashboard/store/actions'

export const HomeHelper = {
    getFooter(params) {
        return ApiServiceHelper.execAction(HOME.GET_FOOTER, params)
    },
    getHomeDetails(params) {
        return ApiServiceHelper.execAction(HOME.GET_HOME_INFO, params)
    },
    getHomeDetailsForAdmin(params) {
        return ApiServiceHelper.execAction(HOME.GET_HOME_INFO_ADMIN, params)
    },
    editHomeDetails(params) {
        return ApiServiceHelper.execAction(HOME.EDIT_DETAILS, params)
    },
    editFooterDetails(params) {
        return ApiServiceHelper.execAction(HOME.EDIT_FOOTER, params)
    },
    createSocialMedia(params) {
        return ApiServiceHelper.execAction(HOME.CREATE_SOCIAL, params)
    },
    storeNewDetails(params) {
        return ApiServiceHelper.execAction(HOME.STORE_NEW_DETAILS, params)
    },
    editService(params) {
        return ApiServiceHelper.execAction(HOME.EDIT_SERVICE, params)
    },
    deleteService(params) {
        return ApiServiceHelper.execAction(HOME.DELETE_SERVICE, params)
    },
    deleteSocialLink(params) {
        return ApiServiceHelper.execAction(HOME.DELETE_SOCAIL_LINK, params)
    },
}
